import { lStorage } from "../../../utils/localStorage/lStorage";
import config from "../config";

export const getDefaultProteinValue = () => ({
    id: "101",
    name: "🍗 Куряче філе",
    energy: 120,
    weight: 100,
});
export const getDefaultGroceryValue = () => ({
    id: "205",
    name: "Вівсяні пластівці",
    energy: 360,
    weight: 100,
});
export const getDefaultOmegaFatValue = () => ({
    id: "306",
    name: "🧴 Оливкова або Лляна Олія",
    energy: 900,
    weight: 15,
});
export const getDefaultTastyValue = () => ({
    id: "409",
    name: "🍏 Яблука",
    energy: 46,
    weight: 250,
});
export const getDefaultCustomValue = () => ({
    id: Math.round(String(Math.random() * 100000)),
    name: "Абра кадабра",
    energy: 9999,
    weight: 100,
});

export const getDefaultDay = () => ({
    dayDate: String(new Date()),
    protein: [],
    grocery: [],
    omegaFats: [],
    tasty: [],
    custom: [],
});

const isSameDay = (date1, date2) => {
    if (
        date1.getDay() === date2.getDay() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear()
    ) {
        return true;
    }
};

const readData = async () => {
    const raw = await lStorage.get("plan/food");
    return raw ?? [];
};

export const readDay = async (date = new Date()) => {
    const rawDays = await readData();

    const day =
        rawDays.find((day) => isSameDay(new Date(day.dayDate), date)) ??
        getDefaultDay();

    const callbackCreator = (propName) => {
        return (existingItem) => {
            const inConfig = config[propName].find(
                (possibleItem) => possibleItem.id === existingItem.id,
            );

            return {
                id: existingItem.id,
                weight: existingItem.weight,
                name: inConfig.name,
                energy: inConfig.energy,
            };
        };
    };

    day.protein = day.protein.map(callbackCreator("protein"));
    day.grocery = day.grocery.map(callbackCreator("grocery"));
    day.omegaFats = day.omegaFats.map(callbackCreator("omegaFats"));
    day.tasty = day.tasty.map(callbackCreator("tasty"));
    day.custom = day.custom;

    return day;
};

export const writeDay = async (day) => {
    const existingDays = await readData();

    const days = existingDays.filter(
        (existingDay) =>
            !isSameDay(new Date(existingDay.dayDate), new Date(day.dayDate)),
    );

    const filteredDay = {
        dayDate: day.dayDate,
        protein: day.protein.map(({ id, weight }) => ({ id, weight })),
        grocery: day.grocery.map(({ id, weight }) => ({ id, weight })),
        omegaFats: day.omegaFats.map(({ id, weight }) => ({ id, weight })),
        tasty: day.tasty.map(({ id, weight }) => ({ id, weight })),
        custom: day.custom,
    };

    days.push(filteredDay);

    await lStorage.set("plan/food", days);
};
